import { useLocation, useParams } from 'react-router-dom'

const CUSTOMER_ADMIN_PATH = /^\/customer\/([^/]+)\/manage(?:\/|$)/

/** Customer id when the user is in client admin (`/customer/:id/manage/...`). */
export function useCustomerAdminCustomerId(): number | undefined {
  const { pathname } = useLocation()
  const { id } = useParams<{ id?: string }>()

  const match = pathname.match(CUSTOMER_ADMIN_PATH)
  const raw = match?.[1] ?? id
  const parsed = Number(raw)

  return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined
}
